import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyBusinessPrioritiesChanges } from '../../api'
import { mapBusinessPriorityToApi, setAllMarketsStatus } from '../../lib'
import { IBusinessPriority } from '../types'

interface ISetAllMarketsStatusArgs {
  record: IBusinessPriority
  status: 'on' | 'off'
}

export const requestBusinessPrioritiesSetAllMarketsStatus = createAsyncThunk(
  'businessPriorities/setAllMarketsStatus',
  ({ record, status }: ISetAllMarketsStatusArgs, { getState }) => {
    const fYear = selectJBPSettingsCurrentFYear(getState())
    const newMarkets = setAllMarketsStatus(record.markets, status)

    const payload = mapBusinessPriorityToApi(
      {
        ...record,
        markets: newMarkets,
      },
      fYear
    )

    return applyBusinessPrioritiesChanges(payload)
  }
)
